import type { CityConfig } from "@/pages/city-template/types";

export const mountVernonConfig: CityConfig = {
  city: "Mount Vernon",
  state: "New York",
  stateAbbr: "NY",
  slug: "mount-vernon",
  route: "/cities/mount-vernon",
  title: "Emergency & Expedited Passport Mount Vernon NY | Same Day Passport",
  metaDescription:
    "Emergency passport Mount Vernon NY — same day, 24-hour, and 3-5 day expedited passport processing for Westchester County. Fast Passport Center serves Mount Vernon, Yonkers, New Rochelle, Pelham, and all lower Westchester communities.",
  h1: "Emergency & Expedited Passport Services in Mount Vernon, NY",
  heroSubtitle:
    "Mount Vernon's fast passport solution — from the City of Homes to lower Westchester. Whether you're flying out of JFK or LaGuardia, Fast Passport Center delivers emergency passports in as little as 24 hours and expedited processing in 3-5 days.",
  heroImageUrl:
    "https://readdy.ai/api/search-image?query=Historic%20downtown%20Mount%20Vernon%20New%20York%20streetscape%20with%20charming%20residential%20homes%20and%20tree-lined%20avenues%2C%20diverse%20suburban%20Westchester%20County%20community%20with%20warm%20golden%20afternoon%20light%2C%20modern%20travel%20photography%20with%20clean%20composition%2C%20no%20text%20overlay%2C%20urban%20New%20York%20scene%20with%20beautiful%20architecture%20and%20greenery&width=1600&height=700&seq=ny-mountvernon-hero-001&orientation=landscape",
  heroImageAlt: "Historic downtown Mount Vernon New York with tree-lined residential streets and charming homes",
  geoPosition: "40.9126; -73.8371",
  geoPlacename: "Mount Vernon, New York, United States",
  lastModified: "2026-05-31",
  regionalAgency: {
    name: "New York Passport Agency",
    address: "376 Hudson Street, New York, NY 10014",
    distance: "~18 miles (Southeast in Manhattan)",
  },
  nearbyCitiesZips: [
    { name: "Mount Vernon", zips: "10550, 10551, 10552, 10553" },
    { name: "Yonkers", zips: "10701, 10702, 10703, 10704, 10705, 10706, 10707, 10708, 10709, 10710, 10701" },
    { name: "New Rochelle", zips: "10801, 10802, 10803, 10804, 10805" },
    { name: "Pelham", zips: "10803" },
    { name: "Pelham Manor", zips: "10803" },
    { name: "Eastchester", zips: "10709" },
    { name: "Bronxville", zips: "10708" },
    { name: "Tuckahoe", zips: "10707" },
    { name: "White Plains", zips: "10601, 10602, 10603, 10604, 10605, 10606, 10607, 10610" },
    { name: "The Bronx", zips: "10451, 10452, 10453, 10454, 10455, 10456, 10457, 10458, 10459, 10460, 10461, 10462, 10463, 10464, 10465, 10466, 10467, 10468, 10469, 10470, 10471, 10472, 10473, 10474, 10475" },
    { name: "New York City", zips: "10001-10282, 11201-11251" },
    { name: "Larchmont", zips: "10538" },
    { name: "Mamaroneck", zips: "10538, 10543" },
    { name: "Harrison", zips: "10528" },
    { name: "Rye", zips: "10580" },
  ],
  benefits: [
    {
      icon: "ri-time-line",
      title: "As Fast as 24 Hours",
      desc: "Emergency passport processing for Mount Vernon travelers with urgent departures — same day service available for documented emergencies.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Registered Courier",
      desc: "U.S. Department of State registered passport courier with direct access to the New York Passport Agency.",
    },
    {
      icon: "ri-customer-service-2-line",
      title: "Real Human Support",
      desc: "Dedicated agents guide you through every step — no chatbots, no automated runaround. Available for Mount Vernon residents 7 days a week.",
    },
    {
      icon: "ri-map-pin-line",
      title: "Lower Westchester County",
      desc: "Mount Vernon, Yonkers, New Rochelle, Pelham, and all lower Westchester communities — we serve all of Westchester County.",
    },
  ],
  testimonials: [
    {
      name: "Marcus J.",
      location: "Fleetwood, Mount Vernon",
      rating: 5,
      text: "Had a family emergency in Jamaica and needed to fly in 3 days. Fast Passport Center got my emergency passport processed in 24 hours. I was on the flight with time to spare.",
      service: "Emergency Passport",
    },
    {
      name: "Angela T.",
      location: "South Side, Mount Vernon",
      rating: 5,
      text: "Renewed my expired passport through Fast Passport Center. Chose the 5-day option and had it back in 4. The agent reviewed all my documents before submission.",
      service: "Passport Renewal",
    },
    {
      name: "David W.",
      location: "Mount Vernon, NY",
      rating: 5,
      text: "First-time passport for my daughter's school trip. The agent helped us with the acceptance clerk appointment at the Mount Vernon post office. Processed in 5 days.",
      service: "New Passport",
    },
  ],
  facilities: [
    {
      id: "mountvernon-1",
      name: "Mount Vernon Main Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "35 South First Avenue",
      city: "Mount Vernon",
      state: "NY",
      zip: "10550",
      phone: "914-668-4110",
      hours: "Mon-Fri 8:30 AM - 5:00 PM, Sat 9:00 AM - 1:00 PM",
      distance: "Downtown Mount Vernon",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major Mount Vernon passport acceptance facility. First-time applicants and those not eligible for mail-in renewal must apply in person.",
      icon: "ri-building-2-line",
    },
    {
      id: "mountvernon-2",
      name: "New Rochelle Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "35 North Avenue",
      city: "New Rochelle",
      state: "NY",
      zip: "10801",
      phone: "914-632-2547",
      hours: "Mon-Fri 8:30 AM - 5:00 PM, Sat 9:00 AM - 1:00 PM",
      distance: "New Rochelle (adjacent)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available by appointment. Convenient for Mount Vernon and New Rochelle residents.",
      icon: "ri-building-2-line",
    },
    {
      id: "mountvernon-3",
      name: "Yonkers Main Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "42 Main Street",
      city: "Yonkers",
      state: "NY",
      zip: "10701",
      phone: "914-969-3830",
      hours: "Mon-Fri 8:30 AM - 5:00 PM, Sat 9:00 AM - 12:00 PM",
      distance: "Yonkers (west of Mount Vernon)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available. Serving Yonkers, Mount Vernon, and lower Westchester communities.",
      icon: "ri-building-2-line",
    },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in Mount Vernon?",
      a: "Fast Passport Center offers same-day emergency passport processing in as little as 24 hours for Mount Vernon residents with documented life-or-death emergencies. For urgent travel within 2 weeks, our 3-5 day expedited service is the most popular option. Standard processing through the post office takes 8-11 weeks.",
    },
    {
      q: "Where is the closest passport acceptance facility in Mount Vernon?",
      a: "The Mount Vernon Main Post Office at 35 South First Avenue is the major Mount Vernon passport acceptance facility. The New Rochelle Post Office at 35 North Avenue and Yonkers Main Post Office at 42 Main Street are also convenient options. First-time applicants and those not eligible for mail-in renewal must apply in person.",
    },
    {
      q: "Can I get same-day passport photos in Mount Vernon?",
      a: "Yes — passport photos are widely available at CVS Pharmacy, Walgreens, UPS Store, and FedEx Office locations throughout Mount Vernon, Yonkers, and New Rochelle. We also offer photo review as part of our service to ensure your 2x2 photos meet all State Department requirements.",
    },
    {
      q: "How much does an expedited passport cost in Mount Vernon?",
      a: "Government fees are set by the State Department and vary based on passport type (book vs card, large book option). Fast Passport Center's service fees depend on processing speed: 10-day Smart Saver, 3-5 day Expedited, or 24-hour Emergency. Call 877-253-0084 for a personalized quote based on your Mount Vernon passport needs.",
    },
    {
      q: "Do I need to visit the New York Passport Agency in person?",
      a: "No — if you use Fast Passport Center, you do not need to visit the New York Passport Agency in Manhattan. As a registered courier, we handle the agency submission for you. The only reason to visit the agency directly is for a documented life-or-death emergency, and appointments are extremely difficult to obtain.",
    },
    {
      q: "What is the fastest way to renew a passport in Mount Vernon?",
      a: "The fastest way to renew a passport in Mount Vernon is through Fast Passport Center's 3-5 day expedited service. If your most recent passport was issued when you were 16 or older, within the last 15 years, and is undamaged, you may qualify for renewal without an acceptance clerk visit. For even faster renewal, our 24-hour emergency service is available.",
    },
    {
      q: "Can I get a child passport expedited in Mount Vernon?",
      a: "Yes — Fast Passport Center expedites child passports for minors under 16 in Mount Vernon and all Westchester County communities. Both parents must appear with the child or provide notarized consent (Form DS-3053). We review all parental consent documentation before submission to avoid delays.",
    },
    {
      q: "Does Fast Passport Center have an office in Mount Vernon?",
      a: "Fast Passport Center operates as a remote courier service — we do not have a physical office in Mount Vernon. We serve the City of Homes and all of Westchester County through our secure overnight shipping and agency submission process. Our headquarters are in Washington, DC.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Mount Vernon", address: "various CVS locations across Mount Vernon, Yonkers, and New Rochelle", hours: "Mon-Sun, hours vary by location" },
    { name: "Walgreens — Mount Vernon", address: "various Walgreens locations throughout Mount Vernon and lower Westchester", hours: "Mon-Sun, hours vary by location" },
    { name: "UPS Store — Mount Vernon", address: "various UPS Store locations in Mount Vernon and New Rochelle", hours: "Mon-Fri 9:00 AM - 7:00 PM, Sat 10:00 AM - 4:00 PM" },
    { name: "FedEx Office — Yonkers", address: "various FedEx Office locations across Yonkers and New Rochelle", hours: "Mon-Fri 8:00 AM - 9:00 PM, Sat-Sun 10:00 AM - 6:00 PM" },
    { name: "Walmart Photo Center — Yonkers", address: "various Walmart locations in Yonkers and New Rochelle", hours: "Mon-Sun 8:00 AM - 10:00 PM" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — Mount Vernon",
      address: "35 St. Pauls Place, Mount Vernon, NY 10550",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Mount Vernon DMV office for license renewals and REAL ID applications. Accepts walk-ins but appointments are strongly recommended.",
      featured: true,
    },
    {
      name: "NYS DMV — Yonkers",
      address: "1 Larkin Center, Yonkers, NY 10710",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Yonkers DMV office serving west Mount Vernon, Yonkers, and lower Westchester residents.",
      featured: false,
    },
    {
      name: "NYS DMV — White Plains",
      address: "200 Hamilton Avenue, White Plains, NY 10601",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "White Plains DMV office serving all Westchester County communities.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "JFK",
      name: "John F. Kennedy International Airport",
      distance: "~20 miles from Mount Vernon",
      address: "Queens, NY 11430",
      note: "Major international airport with flights worldwide. Primary airport for Mount Vernon and lower Westchester travelers.",
      flightUrl: "https://www.jfk.com/",
      flightLabel: "JFK Airport",
      featured: true,
    },
    {
      code: "LGA",
      name: "LaGuardia Airport",
      distance: "~15 miles from Mount Vernon",
      address: "Queens, NY 11371",
      note: "Domestic and international flights. Popular alternative for Mount Vernon residents flying to domestic and Caribbean destinations.",
      flightUrl: "https://www.laguardia.com/",
      flightLabel: "LaGuardia Airport",
      featured: false,
    },
    {
      code: "HPN",
      name: "Westchester County Airport",
      distance: "~20 miles from Mount Vernon",
      address: "240 Airport Road, White Plains, NY 10604",
      note: "Regional airport with flights to major U.S. hubs. Convenient for Westchester County travelers.",
      flightUrl: "https://www.westchestergov.com/airport",
      flightLabel: "HPN Airport",
      featured: false,
    },
  ],
  services: [
    {
      icon: "ri-passport-line",
      title: "Emergency Passport",
      description: "For Mount Vernon travelers with urgent departures within 24 hours to 2 weeks. Direct New York Passport Agency submission with dedicated courier handling.",
      bullets: ["Processing as fast as 24 hours", "Dedicated agent assigned to your case", "Daily status updates"],
      badge: "Fastest",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Fast renewal for Mount Vernon residents with a valid passport issued within the last 15 years at age 16 or older.",
      bullets: ["3-5 day or 10-day options available", "No acceptance clerk visit required", "Secure overnight document return"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-user-add-line",
      title: "New Passport",
      description: "First-time passport application assistance for Mount Vernon residents with step-by-step guidance through the acceptance clerk process.",
      bullets: ["Complete application review before submission", "Acceptance clerk appointment guidance", "3-5 day or 10-day processing options"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alarm-warning-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement service for Mount Vernon residents who have lost their passport or had it stolen.",
      bullets: ["DS-64 form guidance included", "Replacement in 3-5 days or 10 days", "Acceptance clerk visit required"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 in Mount Vernon, with parental consent guidance and acceptance clerk support.",
      bullets: ["Parental consent documentation review", "Both parents present or notarized consent", "3-5 day or 10-day processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal name change for Mount Vernon residents.",
      bullets: ["Marriage certificate or court order review", "Name change in 3-5 days or 10 days", "No clerk visit for most renewals"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for Mount Vernon travelers with immediate departure needs from JFK, LaGuardia, or Westchester County Airport." },
    { name: "Passport Renewal", description: "Fast passport renewal for Mount Vernon residents with a recent valid passport." },
    { name: "New Passport", description: "First-time passport application assistance for Mount Vernon residents." },
    { name: "Lost or Stolen Passport", description: "Passport replacement for Mount Vernon residents who have lost their passport." },
    { name: "Child Passport", description: "Passport services for minors under 16 in Mount Vernon and Westchester County." },
    { name: "Name Change", description: "Passport name change service after marriage, divorce, or legal name change in Mount Vernon." },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Photos must be 2\"x2\" with a plain white or off-white background. Many Mount Vernon travelers get rejected at the acceptance clerk because their photos don't meet strict State Department specs.",
    },
    {
      icon: "ri-file-list-3-line",
      title: "Missing or Incorrect Forms",
      description: "Using the wrong form (DS-11 vs DS-82) or missing required fields can cause weeks of delays. We review every form before submission.",
    },
    {
      icon: "ri-calendar-line",
      title: "Waiting Too Long to Start",
      description: "Standard processing takes 8-11 weeks. Many Mount Vernon travelers wait until the last minute, leaving no buffer for problems.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Incorrect Payment Amount",
      description: "Government fees change frequently. Using an outdated check or wrong amount will cause your application to be returned.",
    },
    {
      icon: "ri-shield-line",
      title: "Damaged or Expired ID",
      description: "Your driver's license or state ID must be valid and unexpired. Many applicants don't realize their ID is about to expire until it's too late.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For child passports, both parents must appear or provide notarized consent. Missing documentation is the #1 reason child applications are delayed.",
    },
  ],
  steps: [
    {
      number: "01",
      icon: "ri-file-list-3-line",
      title: "Complete Your Application",
      description: "Fill out your passport application online or over the phone with our Mount Vernon team. We review everything for accuracy.",
    },
    {
      number: "02",
      icon: "ri-upload-cloud-line",
      title: "Send Us Your Documents",
      description: "Ship your documents via overnight courier to our secure processing center. We confirm receipt and begin review immediately.",
    },
    {
      number: "03",
      icon: "ri-search-line",
      title: "We Review Everything",
      description: "Our agents verify your forms, photos, and supporting documents meet all State Department requirements — no surprises.",
    },
    {
      number: "04",
      icon: "ri-shield-check-line",
      title: "Courier Submission",
      description: "As a registered U.S. Department of State courier, we submit your application directly to the New York Passport Agency.",
    },
    {
      number: "05",
      icon: "ri-passport-line",
      title: "Receive Your Passport",
      description: "Your passport is delivered securely to your Mount Vernon address. We provide tracking and daily status updates throughout.",
    },
  ],
  processingOptions: [
    {
      speed: "8-11",
      unit: "weeks",
      label: "Standard Processing",
      tag: "Post Office",
      tagColor: "bg-gray-200 text-gray-600",
      features: [
        "Mail-in application",
        "No expedited handling",
        "No dedicated agent",
        "No phone or email contact for your case",
        "Updates only by physical mail letter",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "10",
      unit: "business days",
      label: "Smart Saver",
      tag: "Fast Passport Center",
      tagColor: "bg-green-100 text-green-700",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned",
        "Daily status updates",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "3-5",
      unit: "business days",
      label: "Expedited Processing",
      tag: "Recommended",
      tagColor: "bg-[#1A365D] text-white",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "24",
      unit: "hours",
      label: "Emergency Processing",
      tag: "Life or Death",
      tagColor: "bg-red-100 text-red-600",
      features: [
        "For documented life-or-death emergencies only",
        "Requires proof of emergency travel",
        "Strictly for documented life-or-death emergencies",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Must book weeks in advance", fpc: "No appointment needed — we handle agency access" },
    { feature: "Processing Speed", agency: "1-2 business days (if you get an appointment)", fpc: "As fast as 3-5 days or 24 hours for emergencies" },
    { feature: "Document Review", agency: "No pre-check — one mistake means restart", fpc: "Complete review before submission — we catch errors" },
    { feature: "Travel Proof", agency: "Requires printed itinerary with confirmed travel within 2 weeks", fpc: "Flexible documentation requirements" },
    { feature: "Updates", agency: "No phone or email support — only mail updates", fpc: "Daily status updates via phone and email" },
    { feature: "Guarantee", agency: "No guarantee of appointment or same-day processing", fpc: "Reserved agency slots with predictable processing" },
  ],
  stickyNavLinks: [
    { label: "Processing Options", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "New York City", route: "/cities/new-york-city" },
    { name: "Brooklyn", route: "/cities/brooklyn" },
    { name: "Queens", route: "/cities/queens" },
    { name: "The Bronx", route: "/cities/the-bronx" },
    { name: "Staten Island", route: "/cities/staten-island" },
    { name: "Buffalo", route: "/cities/buffalo" },
    { name: "Albany", route: "/cities/albany-ny" },
    { name: "Rochester", route: "/cities/rochester" },
    { name: "Syracuse", route: "/cities/syracuse" },
    { name: "Yonkers", route: "/cities/yonkers" },
    { name: "White Plains", route: "/cities/white-plains" },
    { name: "New Rochelle", route: "/cities/new-rochelle" },
    { name: "Poughkeepsie", route: "/cities/poughkeepsie" },
    { name: "Newburgh", route: "/cities/newburgh" },
    { name: "Kingston", route: "/cities/kingston" },
    { name: "Middletown", route: "/cities/middletown-ny" },
    { name: "New Paltz", route: "/cities/new-paltz" },
    { name: "Binghamton", route: "/cities/binghamton" },
    { name: "Long Island", route: "/cities/long-island" },
    { name: "Elmira", route: "/cities/elmira" },
    { name: "Ithaca", route: "/cities/ithaca" },
    { name: "Corning", route: "/cities/corning" },
    { name: "Jamestown", route: "/cities/jamestown" },
    { name: "Plattsburgh", route: "/cities/plattsburgh" },
    { name: "Watertown", route: "/cities/watertown" },
    { name: "Ogdensburg", route: "/cities/ogdensburg" },
    { name: "Glens Falls", route: "/cities/glens-falls" },
    { name: "New York State", route: "/states/new-york" },
  ],
  fpcOfficeNote:
    "Fast Passport Center serves Mount Vernon and all of Westchester County as a remote courier service. We do not have a physical office in Mount Vernon, but our secure overnight shipping network ensures your documents reach our processing center quickly and safely.",
  fpcOfficeDistance: "Remote courier service — Mount Vernon area",
  serviceAreaIntro:
    "Fast Passport Center provides expedited passport services to Mount Vernon and all of lower Westchester County. From the City of Homes to Yonkers, New Rochelle, and Pelham — we serve the lower Westchester region with the same fast, reliable processing.",
  nearbyCitiesIntro:
    "We proudly serve Mount Vernon and all surrounding communities across lower Westchester County and the Bronx. Whether you're in Fleetwood, South Side, or the North Side, our expedited passport services are available to you.",
  howItWorksIntro:
    "Our Mount Vernon customers follow a simple, proven process to get their passports fast. No agency visits, no waiting in lines, no guessing.",
  mistakesIntro:
    "These are the most common mistakes Mount Vernon travelers make when applying for an expedited passport. Avoiding them saves weeks of delays.",
  testimonialsIntro:
    "Mount Vernon travelers trust Fast Passport Center for their urgent passport needs. Here's what they say about our service.",
  faqIntro:
    "Common questions about emergency and expedited passport services in Mount Vernon. If you don't see your question here, call us at 877-253-0084.",
  statePageRoute: "/states/new-york",
  statePageName: "New York Passport Services",
};

export default mountVernonConfig;